import { useContext, useState } from "react";
import ResponseModal from "../../../../../global/ResponseModal";
import FormSubmitButton from "../../../../../global/FormComponents/FormSubmitButton";
import ApiRequestErrorHandler from "../../../../../global/ApiRequestErrorHandler";
import useService from "../../../../../../hooks/useService";
import ApptBillsList from "./ApptBills/ApptBillsList";
import { StaticBarDispatchContext } from "../StaticBar/context/StaticBarContext";
import { setShouldFetchData } from "../StaticBar/state/actions";

export default function DeleteApptProcedure({
  selectedAppt,
  selectedBills,
  setOpenDeleteBills,
  setProCliTrigger,
  proCliTrigger
}) {
  const dispatch = useContext(StaticBarDispatchContext);
  const administeredServiceRepository = useService('repositories/administered-service-repository');
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  const [openError, setOpenError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpenSuccess = () => {
    setOpenSuccess(!openSuccess);
    setOpenDeleteBills(false);
    setProCliTrigger?.(!proCliTrigger);
    setShouldFetchData(dispatch, true);
  };

  async function handleDelete() {
    setLoading(true);
    try {
      const bills = selectedBills.map((bill) => bill.pk);
      await administeredServiceRepository.deleteBulk(bills);
      setOpenSuccess(!openSuccess);
      setLoading(false);
    } catch (error) {
      const res = error?.response?.data ?? error;
      const errArr = ApiRequestErrorHandler(res);
      setErrorArray(errArr);
      setLoading(false);
      setOpenError(!openError);
    }

  };

  return (
    <div className="justify-center w-full bg-white">
      {!selectedBills ? (
        "Please Select a Administered Service to Continue"
      ) : (
        <>
          <div className="w-1/2 lg:w-[40%]">
            <h2 className="my-4 text-lg font-bold underline">
              Appointment Info
            </h2>
            <div className="flex w-full mb-4 text-sm">
              <span className="w-1/2 mr-2 font-bold">Provider Name:</span>
              <span>{selectedAppt.provider.name}</span>
            </div>
            <div className="flex w-full mb-4 text-sm">
              <span className="w-1/2 mr-2 font-bold">Provider Phone:</span>
              <span>{selectedAppt.provider.phone}</span>
            </div>
            <div className="flex w-full mb-4 text-sm">
              <span className="w-1/2 mr-2 font-bold">Date/Time:</span>
              <span> {new Date(selectedAppt.scheduled).toLocaleString()}</span>
            </div>
          </div>

          <div className="mt-8">
            <h2 className="my-4 text-lg font-bold underline">
              Administered services to be deleted
            </h2>
            <div className="relative">
              <ApptBillsList
                bills={selectedBills}
                isDeleteMode
              />
            </div>
          </div>

          <FormSubmitButton
            isLoading={loading}
            handleSubmit={handleDelete}
            buttonText={
              <h2 className="text-center capitalize">
                Permanently Delete Administered Service<span className="lowercase">(s)</span>
              </h2>
            }
            buttonColor="red"
            sx={{
              textTransform: "capitalize"
            }}
          />
        </>
      )}

      <ResponseModal
        title={openSuccess ? "Administered Service(s)" : "Error Deleting Administered Service(s)"}
        description={openSuccess ? "Successfully deleted the Administered Service(s)" : ""}
        openBool={openSuccess || openError}
        errorMessage={openError ? errorArray : ""}
        isError={openError}
        setOpenBool={openSuccess ? setOpenSuccess : setOpenError}
        handleCloseFunc={openSuccess ? handleOpenSuccess : undefined}
      />

    </div>
  );
}
